
import {Distribution} from '@parantion/components'
import api from '../../../services/api'

export default {
  props: ['readOnly'],

  components: {Distribution},

  computed: {
    feedbackLink () {
      const environment = this.$store.state.parantion.environment !== 'live' ? this.$store.state.parantion.environment + '.' : ''
      return `https://apps.${environment}parantion.nl/formviewer/#/`
    },
    user () {
      return this.$store.state.parantion.user.user
    },
    activeSurvey () {
      return this.$store.getters['survey/getActiveSurvey']
    },
    templateContent () {
      return this.$store.getters['parantion/template/content']
    }
  },

  data () {
    return {
      users: [],
      userCount: {},
      distributionState: {page: 1, filter: 'progress_show-all'}, // contains current page and applied filters,
      searchValue: '',
      noTask: false,
      pageSize: 20
    }
  },

  methods: {
    show () {
      this.$refs.modal.show()
    },
    async deleteUsers ({users}) {
      await this.$store.dispatch('respondent/deleteRespondents', users)
      this.getRespondents()
    },

    async getRespondentsCount () {
      this.userCount = await this.$store.dispatch('survey/getFormUsersCount');
    },

    async getRespondents () {
      this.$refs.distribution.loading = true
      this.getRespondentsCount()
      this.users = this.searchValue === '' ? await this.$store.dispatch('survey/getPagedFormUsers', {fetchObj: this.distributionState, limit: this.pageSize})
              : await this.$store.dispatch('respondent/searchRespondents', this.searchValue);
      this.$refs.distribution.loading = false
      // Update the active survey in case a no-named is being added to the list.
      this.$store.dispatch('survey/retrieveActiveSurvey', this.activeSurvey.fid)
    },

    async getPagedRespondents (distributionState) {
      // prevent double api calls when on same page
      if (this.distributionState.page === distributionState.page && this.distributionState.filter === distributionState.filter) return
      this.$refs.distribution.loading = true
      this.distributionState = distributionState
      this.users = await this.$store.dispatch('survey/getPagedFormUsers',{fetchObj: this.distributionState, limit: this.pageSize})
      this.$refs.distribution.loading = false
    },

    async searchRespondents (searchVal) {
      this.searchValue = searchVal

      if (this.searchValue === '') {
        this.distributionState.page = this.$refs.distribution.page
        return this.getRespondents()
      }

      this.$refs.distribution.loading = true
      this.users = await this.$store.dispatch('respondent/searchRespondents', this.searchValue)
              .catch(() => this.$toasty.error(this.$t('errors.error.msg')))
      this.$refs.distribution.loading = false
    },

    async addRespondents (respondents) {
      this.$refs.distribution.loading = true
      const response = await api.distributionService.setRespondents(this.activeSurvey.fid, respondents)
      if (!response.error) {
        // Update users Used
        setTimeout(async () => {
          let changedUser = this.user
          let changedActiveSurvey = this.activeSurvey
          changedUser.nonamed_users_used = this.user.nonamed_users_used + respondents.length
          changedActiveSurvey.fields.frm_nonamed_users_used = this.activeSurvey.fields.frm_nonamed_users_used + respondents.length
          this.$store.commit('parantion/user/SET_USER', changedUser)
          this.$store.commit('survey/SET_ACTIVE_SURVEY', changedActiveSurvey)
          this.$toasty.success(this.$t('distribution.add_respondent_successful.toast'))
          this.getRespondents()
        }, 1000)
      } else {
        this.$toasty.error(this.$t('errors.error.toast'))
      }
    },

      async generateRespondents ({prefix, count, makeCsvFile}) {
        this.$refs.distribution.loading = true
        const response = await api.distributionService.generateRespondents({formHash: this.activeSurvey.fid, prefix: prefix, count: count, makeCsvFile: makeCsvFile})
        if (!response.error) {
          // Update users Used
          setTimeout(async () => {
            let changedUser = this.user
            let changedActiveSurvey = this.activeSurvey
            changedUser.nonamed_users_used =  parseInt(changedUser.nonamed_users_used ) + parseInt(count)
            changedActiveSurvey.fields.frm_nonamed_users_used = parseInt(changedActiveSurvey.fields.frm_nonamed_users_used ) + parseInt(count)
            this.$store.commit('parantion/user/SET_USER', changedUser)
            this.$store.commit('survey/SET_ACTIVE_SURVEY', changedActiveSurvey)
            this.$toasty.success(this.$t('distribution.add_respondent_successful.toast'))
            this.getRespondents()
          }, 1000)
        } else {
          this.$toasty.error(this.$t('errors.error.toast'))
        }
      },

    async sendInvites (payload) {
      this.$refs.distribution.loading = true
      const inviteObject = {
        text: payload.message,
        subject: payload.subject,
        inviteRespondents: payload.users,
        allRespondents: this.users,
        linkLogin: this.templateContent.properties.linkLogin
      }
      await this.$store.dispatch('respondent/sendInviteToRespondents', inviteObject)
      this.getRespondents()
    },

    async sendReminders (payload) {
      this.$refs.distribution.loading = true
      const remindObject = {
        text: payload.message,
        subject: payload.subject,
        remindRespondents: payload.users,
        allRespondents: this.users,
        linkLogin: this.templateContent.properties.linkLogin
      }
      await this.$store.dispatch('respondent/sendReminderToRespondents', remindObject)
      this.getRespondents()
    },

    async updateUser ({user, value}) {
      let uid = user.uid

      // TODO EAS-1445 dispabled until api can handle this again.
      // this.$store.dispatch('respondent/updateRespondentFields', {
      //   fid: this.activeSurvey.fid,
      //   uid: uid,
      //   email: user.email
      // })

      await this.$store.dispatch('respondent/setRespondentNoRemind', {
        fid: this.activeSurvey.fid,
        uid: uid,
        noReminder: value
      })

      this.$q.notify({
        color: 'green-4',
        textColor: 'black',
        icon: 'check',
        message: this.$t('distribution.edit_respondent_successful.toast')
      })
    },

    /**
     * User object must contain:
     * user.subject.hash - User hash
     * user.container.hash - Form hash
     *
     * @param user
     * @returns {Promise.<void>}
     */
    async openForm (user) {
      let taskObject = await api.userService.getUserTask(user.uid, this.activeSurvey.fid)
      if(!taskObject[0]){
        this.noTask = true
      } else {
        let baseUrl = window.location.origin + '/formviewer/#/?id=' + taskObject[0].tah
        window.open(baseUrl.replace('localhost:8080', 'apps.dev.parantion.nl'))
      }
    },

    async downloadForm (user) {
      let taskObject = await api.userService.getUserTask(user.uid, this.activeSurvey.fid)
      if(!taskObject[0]){
        this.noTask = true
      } else {
        let baseUrl = window.location.origin + '/formviewer/#/?id=' + taskObject[0].tah
        let pdfGenUrl = this.$store.state.parantion.environment === 'live' ? 'https://pdfgenerator.parantion.nl' : 'https://pdfgenerator.dev.parantion.nl'

        baseUrl = baseUrl.replace('http://localhost:8080', 'https://apps.test.parantion.nl')
        baseUrl = baseUrl.replace('.dev.', '.test.')

        window.open(pdfGenUrl + '/ingevulde-vragenlijst?url=' + encodeURIComponent(baseUrl))
      }
    },

    setPageSize(amount) {
      this.pageSize = amount
      this.getRespondents()
    }
  }
}
